import { useTranslation } from 'react-i18next'
import {
	Table,
	TableBody,
	TableCell,
	TableHead,
	TableHeader,
	TableRow,
} from '@/components/ui/table'

interface SpheraFlagDistributionProps {
	/** Valor da coluna Accidents.FlagsCategories de cada linha exportada (vazio = sem flag) */
	flags: string[]
}

/** Quanto cada flag pesa no que está sendo exportado (todas as linhas do filtro, não só a página). */
export function SpheraFlagDistribution({ flags }: SpheraFlagDistributionProps) {
	const { t } = useTranslation()
	if (flags.length === 0) return null

	const counts = new Map<string, number>()
	for (const flag of flags) counts.set(flag, (counts.get(flag) ?? 0) + 1)
	const rows = [...counts.entries()].sort((a, b) => b[1] - a[1])

	return (
		<div className="max-h-72 overflow-y-auto rounded-md border">
			<Table>
				<TableHeader>
					<TableRow>
						<TableHead>Accidents.FlagsCategories</TableHead>
						<TableHead className="text-right">
							{t('administration.spheraExport.distribution.count')}
						</TableHead>
						<TableHead className="text-right">%</TableHead>
					</TableRow>
				</TableHeader>
				<TableBody>
					{rows.map(([flag, count]) => (
						<TableRow key={flag || 'none'}>
							<TableCell className={flag ? undefined : 'text-muted-foreground'}>
								{flag || t('administration.spheraExport.distribution.none')}
							</TableCell>
							<TableCell className="text-right tabular-nums">{count}</TableCell>
							<TableCell className="text-right tabular-nums">
								{((count / flags.length) * 100).toFixed(1)}%
							</TableCell>
						</TableRow>
					))}
				</TableBody>
			</Table>
		</div>
	)
}
